import "reflect-metadata"
import { injectable } from 'inversify-props'
import { ThreadsServiceAdapter } from "@/usecases/threads/adapter/ThreadsServiceAdapter"
import { AxiosRequestConfig } from "axios"
import { findAll } from "@/api/threads"

@injectable()
export class ThreadsService implements ThreadsServiceAdapter {
	findAll = async (params: any, config?: AxiosRequestConfig) => await findAll(params, config)
}